import React from 'react';
import connect from "react-redux/es/connect/connect";
import { Icon, Divider, message } from 'antd';
import cn from "classnames";

import { auth, like } from '../../../../services/firebase/firebase';
import { saveEventAction } from "../../../../actions/userStoreActions";

import IconText from '../../../IconText';
import Like from '../../../Like';
import icons from '../../../icons/icons';

import './Icons.less';

const Icons = ({ entry, savingEvent, setStateHandler, user, saveEventAction }) => {
  const { savedEvents, saveLoadingOptions } = user;

  let isSaved = false;
  if (savedEvents) {
    savedEvents.forEach(id => entry.id === id ? isSaved = true : null);
  }

  const eventSaveHandler = async(id) => {
    const uid = auth().currentUser.uid;
    const { messageType, error } = saveLoadingOptions;

    let newSavedEventList = [...savedEvents];

    if (newSavedEventList.indexOf(id) === -1) {
      newSavedEventList = [...newSavedEventList, id];
    } else {
      newSavedEventList = savedEvents.filter(event => event !== id);
    }

    saveEventAction({uid: uid, newSavedEventList: newSavedEventList});

    if (messageType && messageType === 'success') {
      return message.success('Saved events update');
    }
    if (messageType && messageType === 'error') {
      return message.error(error.message);
    }
  }

  const handleLike = async(id) => {
    fastShowingLike(entry);

    try { await like(id) }
    catch (err) {
      console.error(err);
      if (err.toString() === "TypeError: Failed to fetch") message.error("Server does not respond, try again later")
    }
  }

  const fastShowingLike = (entry) => {
    let liked_users = entry.liked_users;
    let uid = auth().currentUser.uid;
    if(liked_users.includes(uid)){
      let index = liked_users.indexOf(uid);
      liked_users.splice(index, 1)
    } else {
      liked_users.push(uid)
    }
    let newEntry = Object.assign({}, entry, liked_users);
    setStateHandler({ entry: newEntry })
  }

  return (
    <div className="event-actions">
      {
        !entry.isUpcoming && (
          <IconText component={icons.view} text={entry.views || '0'} />
        )
      }
      {
        !entry.isUpcoming && (
          <Divider type="vertical" />
        )
      }
      <Like component={icons.like} entry={entry} handleLike={handleLike}/>
      <Divider type="vertical" />
      {
        savingEvent ? <Icon type="loading" /> : (
          <Icon
            component={isSaved ? icons.savedEventsFilled : icons.savedEvents}
            className={cn({ saved: isSaved }, { disabledButton: true})}
            onClick={() => eventSaveHandler(entry.id)}
          />
        )
      }
      
    </div>
  )
}

export default connect(null, { saveEventAction })(Icons);


// WEBPACK FOOTER //
// ./src/components/Modules/Info/Icons/index.js